import React from 'react';
import HolidaysManagementContextPropsType from './HolidaysManagementContextPropTypes';
import config from './config';

export default React.createContext<HolidaysManagementContextPropsType>(config);
